import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";

import TtProfile from "@/components/modules/profile/TtProfile.vue";
import DdProfile from "@/components/modules/profile/DdProfile.vue";
import MyProfile from "@/components/modules/profile/MyProfile.vue";
import { useQuery } from "@vue/apollo-composable";
import Loader from "@/components/common/Loader.vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const { $t } = useTranslation();



const { result, loading } = useQuery(queries.meWithCreditSummary)


return { __sfc: true,$t, result, loading, TtProfile, DdProfile, MyProfile, Loader }
}

})